import React, { FC, useMemo } from 'react';

import { IFeedbackData, TFeedbackFormType } from './models';

import { FeedbackFormContainer } from './_Container/FeedbackFormContainer';
import { IModalProps } from '@src/core/Modal/models';
import { AnyType } from '@src/models/common';

interface IProps extends Pick<IFeedbackData, 'data'>, Pick<IModalProps, 'importanceLevel'> {
  feedbackFormType?: TFeedbackFormType;
  onClose: () => void;
}

export const FeedbackForm: FC<IProps> = ({ feedbackFormType, onClose, data, importanceLevel }) => {
  const feedbackData = useMemo<AnyType>(() => {
    if (!feedbackFormType) return null;

    return {
      data,
      feedbackFormType,
      importanceLevel,
    };
  }, [data, feedbackFormType, importanceLevel]);

  if (!feedbackData) return null;

  return <FeedbackFormContainer data={feedbackData} onClose={onClose} />;
};
